import { render, staticRenderFns } from "./change-min-height.mpx?vue&type=template&id=636f8a84&isComponent&outputPath=components%2Fchange-min-height67216100%2Findex"
import script from "./change-min-height.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fchange-min-height67216100%2Findex"
export * from "./change-min-height.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fchange-min-height67216100%2Findex"
import style0 from "./change-min-height.mpx?vue&type=style&index=0&id=636f8a84&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_67216100%22%7D&isComponent&outputPath=components%2Fchange-min-height67216100%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports